// components/LocationDisplay.tsx
import { useState, useEffect } from "react";
import { reverseGeocode } from "layouts/EmployeeTickets/reverseGeocode";
import { Typography } from "@mui/material";
interface LocationDisplayProps {
  latitude?: number;
  longitude?: number;
}
const LocationDisplay: React.FC<LocationDisplayProps> = ({
  latitude,
  longitude,
}) => {
  const [location, setLocation] = useState("Loading location...");

  useEffect(() => {
    if (latitude && longitude) {
      reverseGeocode(latitude, longitude)
        .then(setLocation)
        .catch(() => setLocation("Location unknown"));
    } else {
      setLocation("Location data not available");
    }
  }, [latitude, longitude]);

  return (
    <Typography variant="caption" color="textSecondary" component="div">
      {location}
    </Typography>
  );
};

export default LocationDisplay;
